// 顶部导航「全题库 / 高频库」hover 数据

import { defineStore } from 'pinia'
import { ref, watch } from 'vue'
import {
  getPracticeHoverApi,
  getHighFrequencyHoverApi,
  type PracticeHoverData,
  type HighFrequencyHoverData
} from '@/api/nav.api'
import { useUserStore } from '@/store/user.store'

export const useNavHoverStore = defineStore('navHover', () => {
  /** 全题库 hover 数据 */
  const practiceData = ref<PracticeHoverData | null>(null)
  /** 高频库 hover 数据 */
  const highFreqData = ref<HighFrequencyHoverData | null>(null)

  /** 获取全题库 hover 数据 */
  const getPracticeHover = () => {
    return getPracticeHoverApi()
      .then((res) => {
        practiceData.value = res.data
      })
      .catch(() => {
        // 接口失败降级为空态
        practiceData.value = null
      })
  }

  /** 获取高频库 hover 数据 */
  const getHighFrequencyHover = () => {
    return getHighFrequencyHoverApi()
      .then((res) => {
        highFreqData.value = res.data
      })
      .catch(() => {
        // 接口失败降级为空态
        highFreqData.value = null
      })
  }

  /**
   * 进入官网时预取 hover 数据存入缓存，hover 弹窗直接展示，无需等待接口；
   * 页面刷新会重新走应用启动流程再次调用，实现数据更新。
   * 注意：不能依赖 store 内的 onMounted——store 由弹窗 v-if 首次渲染时才实例化，
   * onMounted 会推迟到首次 hover 才触发。
   */
  let inited = false
  const init = () => {
    if (inited) return
    inited = true
    getPracticeHover()
    getHighFrequencyHover()
  }

  // 高频库数据含用户维度字段（练习进度/收藏数）：
  // 未登录进入官网预取的是匿名数据，登录成功后（userInfo.id 从无到有）自动重拉更新
  const userStore = useUserStore()
  watch(
    () => userStore.userInfo?.id,
    (newId, oldId) => {
      if (newId && newId !== oldId) getHighFrequencyHover()
    }
  )

  return {
    practiceData,
    highFreqData,
    getPracticeHover,
    getHighFrequencyHover,
    init
  }
})
